import {
  auth
} from './firebase';

// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () =>
  auth.signOut();

// Send Password Reset Email
export const doSendPasswordResetEmail = (email) =>
  auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);

// Password Reset Code - Verify
export const doVerifyPasswordResetCode = (actionCode) =>
  auth.verifyPasswordResetCode(actionCode);

// Password Reset with new password
export const doPasswordReset = (actionCode, newPassword) =>
  auth.confirmPasswordReset(actionCode, newPassword);

// Verify Email
export const doVerifyEmail = (actionCode) =>
  auth.applyActionCode(actionCode);



// WEBPACK FOOTER //
// ./src/firebase/auth.js